import React, { useState } from 'react'
import { AlertProvider } from './gtoken-k/context/AlertContext';

import { Route, Routes } from 'react-router'
import { SocketProvider } from './gtoken-k/context/SocketContext';
import { MqttProvider } from './gtoken-k/context/MqttContext';

import PortalRootPage from './gtoken-k/app/portal/pages/landing/PortalRootPage';
import PortalLandingPage from './gtoken-k/app/portal/pages/landing/PortalLandingPage';
import SelectQueuePage from './gtoken-k/app/portal/pages/checkin/SelectQueuePage';
import SelectServicesPage from './gtoken-k/app/portal/pages/checkin/SelectServicesPage';
import CheckinFormPage from './gtoken-k/app/portal/pages/checkin/CheckinFormPage';

import SelectScheduleQueuePage from './gtoken-k/app/portal/pages/scheduleCheckin/SelectScheduleQueuePage';
import SelectScheduleServicesPage from './gtoken-k/app/portal/pages/scheduleCheckin/SelectScheduleServicesPage';
import ScheduleCheckinFormPage from './gtoken-k/app/portal/pages/scheduleCheckin/ScheduleCheckinFormPage';


import SelectSlotQueuePage from './gtoken-k/app/portal/pages/slotCheckin/SelectSlotQueuePage';

import TokenDetailsPage from './gtoken-k/app/portal/pages/TokenDetailsPage';
import SelectSlotServicesPage from './gtoken-k/app/portal/pages/slotCheckin/SelectSlotServicesPage';
import SlotCheckinFormPage from './gtoken-k/app/portal/pages/slotCheckin/SlotCheckinFormPage';
import FeedbackFormPage from './gtoken-k/app/portal/pages/feedback/FeedbackFormPage';
import MqttChatPage from './gtoken-k/app/mqtt/pages/MqttChatPage';






function App() {
    sessionStorage.removeItem("businessInfo");
    return (
        <>
        <AlertProvider>
            <SocketProvider>
            
                <Routes>
                    <Route path="/" element={ <PortalRootPage /> } />
                    <Route path="/portal/:portalId" element={ <PortalLandingPage/> } />

                    <Route path="/checkin/queue" element={ <SelectQueuePage/> } />
                    <Route path="/checkin/services" element={ <SelectServicesPage/> } />
                    <Route path="/checkin/form" element={ <CheckinFormPage/> } />

                    <Route path="/schedule-checkin/queue" element={ <SelectScheduleQueuePage /> } />
                    <Route path="/schedule-checkin/services" element={ <SelectScheduleServicesPage /> } />
                    <Route path="/schedule-checkin/form" element={ <ScheduleCheckinFormPage /> } />

                    <Route path="/slot-checkin/queue" element={ <SelectSlotQueuePage /> } />
                    <Route path="/slot-checkin/services" element={ <SelectSlotServicesPage /> } />
                    <Route path="/slot-checkin/form" element={ <SlotCheckinFormPage /> } />
                    
                    <Route path="/feedback-form" element={ <FeedbackFormPage/> } />
                    <Route path="/token-details" element={ <TokenDetailsPage/> } />

                    <Route path="/mqtt/chat" element={ <MqttProvider><MqttChatPage/></MqttProvider> } />
                </Routes>
            </SocketProvider>
        </AlertProvider>
        </>
    )
}
export default App




/*

<Routes>
    <Route path="/" element={ <PortalRootPage/> } />
    <Route path="/portal/:portalId" element={ <PortalLandingPage/> } />
    <Route path="/portal" element={ <SelectQueuePage/> } />
    <Route path="/schedule-checkin" element={ <SchecduleCheckin/> } />
    <Route path="/services/:queueId" element={ <SelectServicesPage/> } />
    <Route path="/checkin/:queueId/:serviceId" element={ <CheckinFormPage/> } />
    <Route path="/token-details" element={ <TokenDetailsPage/> } />
</Routes>

*/